module.exports = __webpack_public_path__ + "img/184.81bf2f1a.jpg";